import {
  yesNoSchema,
  yesNoUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-legal-status-title']),
    validMarriage: yesNoUI({
      title: content['household-legal-status-valid'],
    }),
  },
  schema: {
    type: 'object',
    required: ['validMarriage'],
    properties: {
      validMarriage: yesNoSchema,
    },
  },
};
